import { gql } from "@stadium/services/apollo-client";

export const FETCH_PAGINATED_DRAFT_CATALOG_PRODUCTS = gql`
  query paginatedDraftCatalogProducts(
    $number: String!
    $page: Int = 1
    $perPage: Int = 10
    $iso: String
    $all: Boolean = false
  ) {
    paginatedDraftCatalogProducts(
      number: $number
      page: $page
      perPage: $perPage
      iso: $iso
      all: $all
    ) {
      total
      countryWiseProductCount
      globalProductCount
      totalColorOptions
      totalProductsCount
      products {
        id
        name
        slug
        availableGlobally
        availableCountries {
          iso
          name
        }
        brand {
          id
          name
        }
        images
        selectedColorOptions {
          id
          name
          presentation
        }
        selectedColorsWithTemplate {
          images
          optionValue {
            id
            name
            presentation
          }
        }
      }
    }
  }
`;
